module.exports = __webpack_public_path__ + "img/03李斌.5898aad2.jpg";